var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57025 7.11685V0.373047H8.42975V7.11685H0V18.373H17.9504L18 7.11685H9.57025ZM16.8099 17.183H1.1405V8.20775H8.42975V13.8606L6.34711 11.8772L5.55372 12.7201L8.42975 15.4474V15.497H8.47934L9.02479 16.0425L9.57025 15.497H9.61984L12.3967 12.7697L11.6033 11.9268L9.61984 13.8606V8.20775H16.8595L16.8099 17.183Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Download.ada2bdd6479b0de155094b7563540601.svg";